// extracted by mini-css-extract-plugin
module.exports = {"container":"HorizontalAd_container__6Aymu","iframeWrapper":"HorizontalAd_iframeWrapper__pdF73"};